import { Action, EventObject, sendParent } from 'xstate';
import { Order } from '../../gql/graphql';
import { conditionallySetupTMXSession } from '../../helpers';
import { Role } from '../../types/role';
import { ResolverError } from '../../constants/resolver-error';
import { ErrorMessage } from '../../helpers/security/security';

const initialOrderAction = (queryParams: any, reduxActions: any, orderDetails: Order, role: Role | undefined) => {
  // createOrder if public-dealer-id was provided as query param (for virtual card flows)
  if (!queryParams.orderId && queryParams.dealerIdParams) {
    reduxActions.createOrder({});
  }

  // only query order if !order, app was calling query multiple times
  if (queryParams.orderId && !orderDetails) {
    reduxActions.queryOrder(queryParams.orderId);
    conditionallySetupTMXSession(orderDetails!, role);
  }
};

// TODO: move these
export interface NetworkError {
  resolverErrors: ResolverError[];
  errorGeneral?: ErrorMessage;
  forbiddenError?: ErrorMessage;
  unauthorizedError?: ErrorMessage;
}

export const NETWORK_ERROR = 'NETWORK_ERROR' as const;
export interface NetworkErrorEvent extends EventObject {
  type: typeof NETWORK_ERROR;
  data?: NetworkError;
}

export const sharedActions = {
  // strictly for debugging, do not remove and make sure you clean up references in MRs
  log: (context: any, event: any, meta: any) => {
    console.log('current state:', meta.state?.value);
    console.log('context', context);
    console.log('event', event);
  },
};

export const PropagateNetworkErrors = (): Action<any, any, any> => {
  return sendParent((context: any, event: any) => ({ type: 'NETWORK_ERROR', data: event?.data }));
};

export { initialOrderAction };
